import React, { useState } from 'react';
import { View, Text, TouchableOpacity, StyleSheet } from 'react-native';

interface MaterialCalendarProps {
  onSelectMonth: (month: Date) => void;
}

export const MaterialCalendar: React.FC<MaterialCalendarProps> = ({ onSelectMonth }) => {
  const [selectedMonth, setSelectedMonth] = useState<Date | null>(null);
  const [selectedYear, setSelectedYear] = useState<number>(new Date().getFullYear());

  const currentYear = new Date().getFullYear();
  const minYear = currentYear;
  const maxYear = currentYear + 3;

  const handleMonthPress = (month: Date) => {
    setSelectedMonth(month);
    onSelectMonth(month);
  };

  const handlePrevYearPress = () => {
    setSelectedYear(selectedYear - 1);
  };

  const handleNextYearPress = () => {
    setSelectedYear(selectedYear + 1);
  };

  const isMonthSelected = (month: Date) => {
    if (!selectedMonth) return false;
    return month.getFullYear() === selectedMonth.getFullYear() && month.getMonth() === selectedMonth.getMonth();
  };

  const renderCalendarMonths = () => {
    const monthsInYear = 12;
    const months = [];
    for (let i = 0; i < monthsInYear; i++) {
      const month = new Date(selectedYear, i);
      const isSelected = isMonthSelected(month);

      months.push(
        <TouchableOpacity
          key={i}
          style={[styles.monthContainer, isSelected && styles.selectedMonth]}
          onPress={() => handleMonthPress(month)}
        >
          <Text style={[styles.monthText, isSelected && styles.selectedMonthText]}>
            {month.toLocaleString('default', { month: 'short' })}
          </Text>
        </TouchableOpacity>,
      );
    }
    return months;
  };

  return (
    <View>
      <View style={styles.yearContainer}>
        <TouchableOpacity onPress={handlePrevYearPress} disabled={selectedYear === minYear}>
          <Text style={styles.arrowText}>&lt;</Text>
        </TouchableOpacity>
        <Text style={styles.yearText}>{selectedYear}</Text>
        <TouchableOpacity onPress={handleNextYearPress} disabled={selectedYear === maxYear}>
          <Text style={styles.arrowText}>&gt;</Text>
        </TouchableOpacity>
      </View>
      <View style={styles.calendarContainer}>{renderCalendarMonths()}</View>
    </View>
  );
};

const styles = StyleSheet.create({
  yearContainer: {
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  yearText: {
    fontSize: 16,
    fontWeight: 'bold',
  },
  arrowText: {
    fontSize: 20,
    fontWeight: 'bold',
    marginLeft: 15,
    marginRight: 15,
  },
  calendarContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    paddingHorizontal: 16,
    paddingVertical: 8,
  },
  monthContainer: {
    width: '20%',
    aspectRatio: 1,
    height: 50,
    justifyContent: 'center',
    alignItems: 'center',
    borderRadius: 25,
    margin: 2,
    backgroundColor: '#fff',
  },
  monthText: {
    fontSize: 14,
    fontWeight: 'bold',
  },
  selectedMonth: {
    backgroundColor: 'gray',
  },
  selectedMonthText: {
    color: '#fff',
  },
});

export default MaterialCalendar;
